import styled from "@emotion/styled";
import get from "lodash/get";

const Scrollbar = styled.div(({ scrollStyles }) => ({
  width: "100%",
  height: "50vh",
  maxHeight: "900px",
  overflowY: "auto",
  scrollbarColor: scrollStyles?.isHideScrollBar ? "" : "white blue",
  padding: 20,
  margin: 2,
  "::-webkit-scrollbar": {
    width: scrollStyles?.isHideScrollBar ? "0px" : "8px"
  },
  "::-webkit-scrollbar-thumb:hover": {
    background: "lightBlue",
    maxHeight: "10px",
    ...get(scrollStyles, "scrollbarThumbhover", {})
  },
  "::-webkit-scrollbar-track": {
    boxShadow: "nset 0 0 6px grey",
    borderRadius: "5px"
  },
  "::-webkit-scrollbar-thumb": {
    background: "#0015C4",
    borderRadius: "15px",
    height: "2px",
    ...get(scrollStyles, "scrollbarThumb", {})
  }
}));

export default Scrollbar;
